import { User } from '@modules/auth/hooks/types'

export enum userSubscriptionLevel {
  FREE_USER = 1,
  SUBSCRIBED_USER = 2,
  VENDOR = 3,
  ECOMMERCE = 4,
}

export const isP1PlusNotFreeUser = (subscriptionLevel?: User['subscriptionLevel']) => {
  return [userSubscriptionLevel.SUBSCRIBED_USER, userSubscriptionLevel.VENDOR].includes(subscriptionLevel ?? 0)
}

export const isP1PlusEcommerceUser = (subscriptionLevel?: User['subscriptionLevel']) => {
  return Boolean(subscriptionLevel && subscriptionLevel === userSubscriptionLevel.ECOMMERCE)
}
